import { render, staticRenderFns } from "./BillingDetail.vue?vue&type=template&id=2deef584"
import script from "./BillingDetail.vue?vue&type=script&lang=ts"
export * from "./BillingDetail.vue?vue&type=script&lang=ts"
import style0 from "./BillingDetail.vue?vue&type=style&index=0&id=2deef584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports